import React from "react";

const Content = () => {
  return (
    <>
      <section>
        <span id="started"> &nbsp; </span>

        <h2>Getting Started</h2>

        <p>
          NumVerify offers a full-featured yet simple RESTful JSON API for
          national and international phone number validation and information
          lookup for a total of 232 countries around the world.
        </p>

        <p>
          Requested numbers are processed in real-time, cross-checked with the
          latest international numbering plan databases and returned in handy
          JSON format enriched with useful carrier, geographical location and
          line type data.
        </p>

        <p>
          Integrating the numverify API into your application will enable you to
          verify the validity of phone numbers at the point of entry, protecting
          you from fraud and increasing good leads.
        </p>
      </section>

      <section>
        <h1>Specs and Overview</h1>
        <h2>Getting Started</h2>

        <p>
          NumVerify offers a full-featured yet simple RESTful JSON API for
          national and international phone number validation and information
          lookup for a total of 232 countries around the world.
        </p>

        <p>
          Requested numbers are processed in real-time, cross-checked with the
          latest international numbering plan databases and returned in handy
          JSON format enriched with useful carrier, geographical location and
          line type data.
        </p>

        <p>
          Integrating the numverify API into your application will enable you to
          verify the validity of phone numbers at the point of entry, protecting
          you from fraud and increasing good leads.
        </p>
      </section>

      <section>
        <span id="changelog"> &nbsp; </span>

        <h1>Changelog</h1>

        <p>
          NumVerify offers a full-featured yet simple RESTful JSON API for
          national and international phone number validation and information
          lookup for a total of 232 countries around the world.
        </p>

        <p>
          Requested numbers are processed in real-time, cross-checked with the
          latest international numbering plan databases and returned in handy
          JSON format enriched with useful carrier, geographical location and
          line type data.
        </p>

        <h2>More about API</h2>

        <p>
          Integrating the numverify API into your application will enable you to
          verify the validity of phone numbers at the point of entry, protecting
          you from fraud and increasing good leads.
        </p>

        <p>
          Integrating the numverify API into your application will enable you to
          verify the validity of phone numbers at the point of entry, protecting
          you from fraud and increasing good leads.
        </p>
      </section>

      <section>
        <span id="idVerified"> &nbsp; </span>

        <h1>ID Verification</h1>
        <h2>Getting Started</h2>

        <p>
          NumVerify offers a full-featured yet simple RESTful JSON API for
          national and international phone number validation and information
          lookup for a total of 232 countries around the world.
        </p>

        <p>
          Requested numbers are processed in real-time, cross-checked with the
          latest international numbering plan databases and returned in handy
          JSON format enriched with useful carrier, geographical location and
          line type data.
        </p>

        <h2>More about API</h2>

        <p>
          Integrating the numverify API into your application will enable you to
          verify the validity of phone numbers at the point of entry, protecting
          you from fraud and increasing good leads.
        </p>

        <p>
          Integrating the numverify API into your application will enable you to
          verify the validity of phone numbers at the point of entry, protecting
          you from fraud and increasing good leads.
        </p>

        <h2>Key</h2>

        <p>
          Integrating the numverify API into your application will enable you to
          verify the validity of phone numbers at the point of entry, protecting
          you from fraud and increasing good leads.
        </p>

        <p>
          Integrating the numverify API into your application will enable you to
          verify the validity of phone numbers at the point of entry, protecting
          you from fraud and increasing good leads.
        </p>

        <code>http://apilayer.net/api/validate?access_key=YOUR_ACCESS_KEY</code>

        <p>
          NumVerify offers a full-featured yet simple RESTful JSON API for
          national and international phone number validation and information
          lookup for a total of 232 countries around the world.
        </p>

        <p>
          Requested numbers are processed in real-time, cross-checked with the
          latest international numbering plan databases and returned in handy
          JSON format enriched with useful carrier, geographical location and
          line type data.
        </p>
      </section>

      <section>
        <span id="kycVerified"> &nbsp; </span>

        <h1>KYC Verification</h1>

        <p>
          NumVerify offers a full-featured yet simple RESTful JSON API for
          national and international phone number validation and information
          lookup for a total of 232 countries around the world.
        </p>

        <h2>Intro</h2>

        <p>
          NumVerify offers a full-featured yet simple RESTful JSON API for
          national and international phone number validation and information
          lookup for a total of 232 countries around the world.
        </p>

        <p>
          Requested numbers are processed in real-time, cross-checked with the
          latest international numbering plan databases and returned in handy
          JSON format enriched with useful carrier, geographical location and
          line type data.
        </p>

        <h2>More about API</h2>

        <p>
          Integrating the numverify API into your application will enable you to
          verify the validity of phone numbers at the point of entry, protecting
          you from fraud and increasing good leads.
        </p>

        <p>
          Integrating the numverify API into your application will enable you to
          verify the validity of phone numbers at the point of entry, protecting
          you from fraud and increasing good leads.
        </p>

        <h2>Key</h2>

        <p>
          Integrating the numverify API into your application will enable you to
          verify the validity of phone numbers at the point of entry, protecting
          you from fraud and increasing good leads.
        </p>

        <p>
          Integrating the numverify API into your application will enable you to
          verify the validity of phone numbers at the point of entry, protecting
          you from fraud and increasing good leads.
        </p>

        <code>http://apilayer.net/api/validate?access_key=YOUR_ACCESS_KEY</code>

        <p>
          NumVerify offers a full-featured yet simple RESTful JSON API for
          national and international phone number validation and information
          lookup for a total of 232 countries around the world.
        </p>

        <p>
          Requested numbers are processed in real-time, cross-checked with the
          latest international numbering plan databases and returned in handy
          JSON format enriched with useful carrier, geographical location and
          line type data.
        </p>
      </section>

      <section>
        <span id="otpVerified"> &nbsp; </span>

        <h1>OTP Verification</h1>

        <p>
          NumVerify offers a full-featured yet simple RESTful JSON API for
          national and international phone number validation and information
          lookup for a total of 232 countries around the world.
        </p>

        <h2>Intro</h2>

        <p>
          NumVerify offers a full-featured yet simple RESTful JSON API for
          national and international phone number validation and information
          lookup for a total of 232 countries around the world.
        </p>

        <p>
          Requested numbers are processed in real-time, cross-checked with the
          latest international numbering plan databases and returned in handy
          JSON format enriched with useful carrier, geographical location and
          line type data.
        </p>

        <h2>OTP API</h2>

        <p>
          Integrating the numverify API into your application will enable you to
          verify the validity of phone numbers at the point of entry, protecting
          you from fraud and increasing good leads.
        </p>

        <p>
          Integrating the numverify API into your application will enable you to
          verify the validity of phone numbers at the point of entry, protecting
          you from fraud and increasing good leads.
        </p>

        <h2>Keys</h2>

        <p>
          Integrating the numverify API into your application will enable you to
          verify the validity of phone numbers at the point of entry, protecting
          you from fraud and increasing good leads.
        </p>

        <p>
          Integrating the numverify API into your application will enable you to
          verify the validity of phone numbers at the point of entry, protecting
          you from fraud and increasing good leads.
        </p>

        <code>http://apilayer.net/api/validate?access_key=YOUR_ACCESS_KEY</code>

        <p>
          NumVerify offers a full-featured yet simple RESTful JSON API for
          national and international phone number validation and information
          lookup for a total of 232 countries around the world.
        </p>

        <p>
          Requested numbers are processed in real-time, cross-checked with the
          latest international numbering plan databases and returned in handy
          JSON format enriched with useful carrier, geographical location and
          line type data.
        </p>

        <code>
          http://apilayer.net/api/validate ? access_key = YOUR_ACCESS_KEY &
          number = 14158586273
        </code>

        <p>
          Requested numbers are processed in real-time, cross-checked with the
          latest international numbering plan databases and returned in handy
          JSON format enriched with useful carrier, geographical location and
          line type data.
        </p>
      </section>
    </>
  );
};

export default Content;
